import { getData } from '../../../helpers/axiosHelper';
import { FEATURE_ENPOINT } from '../consts';
import {
  IGetFeatureAvailableResponse,
  IGetFeaturesByCustomerIdResponse,
} from '../types';

export const getFeaturesByCustomerId = async (
  customerId: string
): Promise<IGetFeaturesByCustomerIdResponse> => {
  const url = `${FEATURE_ENPOINT}/features-by-customer?customerId=${customerId}`;
  return getData(url);
};

export const IsFeatureAvailableForCustomer = async (
  customerId: string,
  featureName: string
): Promise<IGetFeatureAvailableResponse> => {
  const url = `${FEATURE_ENPOINT}/features/${featureName}/customers/${customerId}`;
  return getData(url);
};
